import React, { useEffect, useState } from "react";
import { useModel } from "../../../Api/newSockets.api";
import { NavLink, useLocation } from "react-router-dom";

import ImageAnnotate from "../../../components/Annotation/AnnotationImage";

import { ReactComponent as ArrowDownIcon } from "../../../assets/icons/arrow_down.svg";
import AddButton from "../../../components/Buttons/AddButton";
import Header from "../../../components/Header/Header";
import LoadingSpinner from "../../../components/LoadingSpinner/LoadingSpinner";
import { savePathToLocalStorage } from "../../../utils/helpers";

const Model = (props) => {
  savePathToLocalStorage();
  const [model, setModel] = useState<any>();
  const { getModel, connected } = useModel();

  useEffect(() => {
    getModel(parseInt(props.match.params.id)).then((data: any) => {
      setModel(data);
    });
  }, [connected]);

  return model ? (
    <div className="dataset-main develop-main">
      <Header title={model.name} goBackTo={"/data/models"} />

      <section className="develop">
        {/* <ImageAnnotate model={model} /> */}
      </section>
    </div>
  ) : (
    <LoadingSpinner />
  );
};

export default Model;
